var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.thumbnailUrl)?_c('div',{staticClass:"containerThumbnail",style:('background-image:url('+_vm.thumbnailUrl+');')},[_c('WeetSpeedSelectorPlayer',{staticClass:"speedSelector",attrs:{"weet":_vm.weet}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }